import styled from "@emotion/styled";

export const TableWrapper = styled.div`
  display: none;

  @media screen and (min-width: ${p => p.theme.screenSizes.mdMax}) {
    display: grid;
    grid-template-columns: ${p =>
      p.showStatus ? (p.gridSettings ?? "1fr 1fr 187px") : "1fr 1fr"};
    gap: 0;
  }
`;

export const Row = styled.div`
  display: contents;
`;
